import dayjs from "dayjs";
import { ApiAdminDashboard } from "utils/api/admin/dashboard";

const getCardCounts = ({ issuedByDate, usedByDate }) =>
  issuedByDate.reduce((arr, card, i) => {
    const { date, value: issued } = card;
    const used = usedByDate[i].value;

    return [
      ...arr,
      {
        date,
        issued,
        used,
      },
    ];
  }, []);

export const getChartsData = (data: ApiAdminDashboard) => ({
  transactionCount: {
    daily: data.dailyTransactionCount,
    monthly: data.monthlyTransactionCount,
  },
  cardSpend: {
    daily: data.dailyCardSpend,
    monthly: data.monthlyCardSpend,
  },
  cardCount: {
    daily: getCardCounts({
      issuedByDate: data.dailyCardsIssued,
      usedByDate: data.dailyCardsUsed,
    }),
    monthly: getCardCounts({
      issuedByDate: data.monthlyCardsIssued,
      usedByDate: data.monthlyCardsUsed,
    }),
  },
});

export const getMonthlyDataWithProjection = (
  monthlyData,
  valueKeys = ["value"]
) => {
  const daysInMonth = dayjs().daysInMonth();
  const dayOfMonth = dayjs().date();
  const currentMonthData = monthlyData[monthlyData.length - 1];
  const previousMonths = monthlyData.slice(0, -1);
  const currentMonthWithProjection = valueKeys.reduce(
    (obj, key) => ({
      ...obj,
      [key]: Math.round(currentMonthData[key] * (daysInMonth / dayOfMonth)),
    }),
    { ...currentMonthData }
  );
  const monthlyDataWithProjection = [
    ...previousMonths,
    currentMonthWithProjection,
  ];
  return monthlyDataWithProjection;
};

// export const getChartsDataProjected = (chartsData) => ({
//   transactionCount: {
//     daily: chartsData.transactionCount.daily,
//     monthly: getMonthlyDataWithProjection(chartsData.transactionCount.monthly),
//   },
//   cardSpend: {
//     daily: chartsData.cardSpend.daily,
//     monthly: getMonthlyDataWithProjection(chartsData.cardSpend.monthly),
//   },
//   cardCount: {
//     daily: chartsData.cardCount.daily,
//     monthly: getMonthlyDataWithProjection(chartsData.cardCount.monthly, [
//       "issued",
//       "used",
//     ]),
//   },
// });
